
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/geo",
      function () {
        return require("private-next-pages/geo.js");
      }
    ]);
  